"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewerTableAdvancedFilter = exports.fieldSpecifierMap = void 0;
const react_1 = require("react");
const predicate_language_1 = require("@groupby/predicate-language");
const debounce_1 = __importDefault(require("debounce"));
const use_filter_utils_1 = require("./use-filter.utils");
const filter_utils_1 = require("../product-viewer/filter/filter.utils");
const filter_1 = require("../product-viewer/filter");
const store_1 = require("../../store");
const State = __importStar(require("../../store/state"));
const OPERATOR_TO_PREDICATE = {
    [filter_1.FilterOperator.Is]: '==',
    [filter_1.FilterOperator.IsNot]: '!=',
    [filter_1.FilterOperator.Before]: '<',
    [filter_1.FilterOperator.After]: '>',
    [filter_1.FilterOperator.Contains]: '=~',
    [filter_1.FilterOperator.DoesNotContain]: '!~',
    [filter_1.FilterOperator.StartsWith]: '=~',
    [filter_1.FilterOperator.EndsWith]: '=~',
};
exports.fieldSpecifierMap = {
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID]: 'id',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID]: 'proprietaryId',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.NAME]: 'title',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION]: 'description',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP]: 'variantGroupId',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.URL]: 'url',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS]: 'classId',
    [State.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS]: 'active',
};
const useViewerTableAdvancedFilter = () => {
    const [filter, setFilter] = (0, react_1.useState)(new predicate_language_1.PredicateBuilder());
    const advancedFilterData = (0, store_1.useAdvancedViewerFilterData)();
    const formatValue = (field, value, operator) => {
        if ((0, filter_utils_1.isUuidField)(field))
            return (0, predicate_language_1.uuid)(value);
        if (operator === filter_1.FilterOperator.Contains || operator === filter_1.FilterOperator.DoesNotContain)
            return new RegExp(value, 'i');
        if (operator === filter_1.FilterOperator.StartsWith)
            return new RegExp(`^${value}.*`, 'i');
        if (operator === filter_1.FilterOperator.EndsWith)
            return new RegExp(`.*${value}$`, 'i');
        if ((0, filter_utils_1.isDateFilter)(field))
            return value[0];
        return value;
    };
    const createBasicPredicate = ({ field, operator, value, }) => {
        const formattedValue = formatValue(field, value, operator);
        return (0, predicate_language_1.where)((0, predicate_language_1.f) `${field}`, OPERATOR_TO_PREDICATE[operator], formattedValue);
    };
    const createDateRangePredicate = ({ field, value }) => {
        const [startDate, endDate] = value;
        return ((0, predicate_language_1.where)((0, predicate_language_1.f) `${field}`, '>', startDate).and((0, predicate_language_1.f) `${field}`, '<', endDate));
    };
    const createAttributePredicate = ({ attribute, value, operator }) => {
        const { id, name } = JSON.parse(value);
        const predicate = (0, predicate_language_1.where)((0, predicate_language_1.f) `attributes`, '@>', (id || name) ? (0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '==', (0, predicate_language_1.uuid)(attribute))
            .and((0, predicate_language_1.where)((0, predicate_language_1.f) `values`, '@>', (0, predicate_language_1.where)(id ? (0, predicate_language_1.f) `id` : (0, predicate_language_1.f) `name`, '==', id ? (0, predicate_language_1.uuid)(id) : name))) : (0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '==', (0, predicate_language_1.uuid)(attribute)));
        if (operator === filter_1.FilterOperator.IsNot) {
            return (0, predicate_language_1.not)(predicate);
        }
        return predicate;
    };
    const createValuePredicate = ({ value, operator }) => {
        const idsArray = JSON.parse(value);
        let predicate;
        if (idsArray.length === 1) {
            predicate = (0, predicate_language_1.where)((0, predicate_language_1.f) `attributes`, '@>', (0, predicate_language_1.where)((0, predicate_language_1.f) `values`, '@>', ((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '==', (0, predicate_language_1.uuid)(idsArray[0])))));
        }
        else {
            predicate = idsArray.reduce((filter, id) => {
                filter.or((0, predicate_language_1.where)((0, predicate_language_1.f) `attributes`, '@>', (0, predicate_language_1.where)((0, predicate_language_1.f) `values`, '@>', ((0, predicate_language_1.where)((0, predicate_language_1.f) `id`, '==', (0, predicate_language_1.uuid)(id))))));
                return filter;
            }, new predicate_language_1.PredicateBuilder());
        }
        if (operator === filter_1.FilterOperator.IsNot) {
            return (0, predicate_language_1.not)(predicate);
        }
        return predicate;
    };
    const generatePredicate = (filters) => {
        const predicate = filters.reduce((filter, { field, operator, value, fieldSpecifier = null, connector, }) => {
            const logicalOperator = (0, use_filter_utils_1.getLogicalOperator)(connector);
            if (field === filter_1.FilterField.TaxonomyClass || field === filter_1.FilterField.Category) {
                filter[logicalOperator](createBasicPredicate({ field, operator, value }));
            }
            if ((0, filter_utils_1.isDateFilter)(field)) {
                if (operator === filter_1.FilterOperator.Between) {
                    filter[logicalOperator](createDateRangePredicate({ field, value }));
                }
                else {
                    filter[logicalOperator](createBasicPredicate({ field, operator, value }));
                }
            }
            if (field === filter_1.FilterField.Field) {
                filter[logicalOperator](createBasicPredicate({ field: exports.fieldSpecifierMap[fieldSpecifier], operator, value }));
            }
            if (field === filter_1.FilterField.Attribute) {
                filter[logicalOperator](createAttributePredicate({ attribute: fieldSpecifier, value, operator }));
            }
            if (field === filter_1.FilterField.Value) {
                filter[logicalOperator](createValuePredicate({ value, operator }));
            }
            return filter;
        }, new predicate_language_1.PredicateBuilder());
        setFilter(predicate);
    };
    const debouncedGeneratePredicate = (0, debounce_1.default)(generatePredicate, 300);
    (0, react_1.useEffect)(() => {
        const isFilterReady = ({ field, value, operator, fieldSpecifier, }) => {
            if (!field || !operator) {
                return false;
            }
            if ((0, filter_utils_1.isDateFilter)(field)) {
                if (!Array.isArray(value)) {
                    return false;
                }
                if (operator === filter_1.FilterOperator.Between) {
                    return !!value[0] && !!value[1];
                }
                return !!value[0];
            }
            if (field === filter_1.FilterField.Field) {
                return !!fieldSpecifier && !!exports.fieldSpecifierMap[fieldSpecifier] && !!value;
            }
            if (field === filter_1.FilterField.Attribute) {
                return !!fieldSpecifier && !!value;
            }
            return !!value;
        };
        if (advancedFilterData.every(isFilterReady)) {
            debouncedGeneratePredicate(advancedFilterData);
        }
    }, [advancedFilterData]);
    return { advancedFilter: filter };
};
exports.useViewerTableAdvancedFilter = useViewerTableAdvancedFilter;
